import React, { FC, useEffect, useState } from "react";
import {
  Typography,
  Select,
  MenuItem,
  SelectChangeEvent,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FormNotes from "../FormNotes/FormNotes";
import { styled } from "@mui/material/styles";
import { blueGrey } from "@mui/material/colors";
import dealerRoles from "../../util/dealerAccounts";

const StyledDivCol = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  width: "100%",
});

const StyledSpanErr = styled("span")({
  color: "red",
  fontSize: 22,
});

const StyledInputDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingBottom: 20,
});

const StyledLabel = styled(Typography)({
  width: 120,
  flexShrink: 0,
  textAlign: "right",
  marginRight: 5,
});

const StyledInput = styled("input")(({ theme }) => ({
  backgroundColor: blueGrey[50],
  border: "1px solid grey",
  borderRadius: "4px",
  height: "30px",
  width: 300,
  [theme.breakpoints.down("sm")]: {
    width: 150,
    marginLeft: 5,
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: blueGrey[50],
  border: "1px solid grey",
  borderRadius: "4px",
  height: "30px",
  width: 300,
  [theme.breakpoints.down("sm")]: {
    width: 150,
    marginLeft: 5,
  },
}));

interface ProjectNameProps {
  handleAllChange: (
    event:
      | SelectChangeEvent<unknown>
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
  role: string;
  signedInUserRole: string,
  jobName: string;
  formNotes: string;
  agSalesperson: string;
  leadNumber: string;
}

const ProjectName: FC<ProjectNameProps> = ({
  handleAllChange,
  role,
  signedInUserRole,
  jobName,
  formNotes,
  agSalesperson,
  leadNumber,
}) => {
  const agSales = [
    "George Robles",
    "John Walowich",
    "Arnold Montes",
    "Jeff O'Neill",
    "Laura Downey",
  ];

  const [showLeadNumber, setShowLeadNumber] = useState(false);

  const disabled = dealerRoles.includes(signedInUserRole || "");

  const hideLeadNumber = () => {
    setShowLeadNumber(false);
  };

  useEffect(() => {
    if (leadNumber) {
      setShowLeadNumber(true);
    }
  }, [leadNumber]);

  return (
    <StyledDivCol>
      <StyledInputDiv>
        <StyledLabel variant="body2">
          Project Name:
          <StyledSpanErr>* </StyledSpanErr>
        </StyledLabel>
        <StyledInput
          maxLength={20}
          onChange={handleAllChange}
          name="jobName"
          value={jobName}
          placeholder="Project Name"
        />
      </StyledInputDiv>

      <StyledInputDiv>
        <StyledLabel variant="body2">
          AG Sales Rep:
          <StyledSpanErr>* </StyledSpanErr>
        </StyledLabel>
        {!disabled && role !== "Outside Sales" ? (
          <StyledSelect
            onChange={handleAllChange}
            name="agSalesperson"
            value={agSalesperson}
            placeholder="Ag Sales Rep"
          >
            {agSales.map((salesperson) => (
              <MenuItem value={salesperson} key={salesperson}>
                {salesperson}
              </MenuItem>
            ))}
          </StyledSelect>
        ) : (
          <StyledInput
            disabled={true}
            onChange={handleAllChange}
            name="agSalesperson"
            value={agSalesperson}
            placeholder="Ag Sales Rep"
          />
        )}
      </StyledInputDiv>

      {!disabled &&
        (showLeadNumber ? (
          <StyledInputDiv style={{ paddingBottom: 0 }}>
            <StyledLabel variant="body2">Lead Number:</StyledLabel>
            <StyledInput
              maxLength={16}
              onChange={handleAllChange}
              name="leadNumber"
              value={leadNumber}
              style={{ width: "270px" }}
            />
            <Tooltip
              title={leadNumber ? "Hide Lead Number" : null}
              placement="top"
            >
              <IconButton
                style={{ width: "30px", marginLeft: "5px" }}
                onClick={hideLeadNumber}
              >
                <CloseIcon style={{ width: "25px" }} />
              </IconButton>
            </Tooltip>
          </StyledInputDiv>
        ) : (
          <Button
            size="small"
            color="customGrey"
            onClick={() => setShowLeadNumber(true)}
          >
            {leadNumber ? "View Lead Number" : "+ Add Lead Number"}
          </Button>
        ))}

      <FormNotes formNotes={formNotes} handleChange={handleAllChange} />
    </StyledDivCol>
  );
};

export default ProjectName;
